import { Button } from '@sunwebgroup/uds-ui/button'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import * as React from 'react'
import { useIntl } from '@/intl'
import { useGroupResponsibleStore } from '@/scopes/account/group-responsible/infrastructure/useGroupResponsibleStore'
import { useGroupResponsibleUseCases } from '@/scopes/account/group-responsible/pages/dependencies'
import { getChangedRoomsCount, hasStagedRoomChanges, hasUnassignedStagedParticipants } from '../selectors'
import { FloatingToolbar } from './FloatingToolbar'
import styles from './RoomStagingToolbar.module.css'

export function RoomStagingToolbar() {
  const intl = useIntl()
  const useCases = useGroupResponsibleUseCases()
  const hasChanges = useGroupResponsibleStore(hasStagedRoomChanges)
  const changedCount = useGroupResponsibleStore(getChangedRoomsCount)
  const hasUnassignedParticipants = useGroupResponsibleStore(hasUnassignedStagedParticipants)
  const roomAssignmentStatus = useGroupResponsibleStore(state => state.roomAssignmentStatus)
  const discardStagedRoomAssignments = useGroupResponsibleStore(
    state => state.discardStagedRoomAssignments,
  )

  if (!hasChanges) {
    return null
  }

  const isSubmitting = roomAssignmentStatus === 'submitting'
  const isAwaitingConfirmation = roomAssignmentStatus === 'pending' || roomAssignmentStatus === 'processing' || roomAssignmentStatus === 'refreshing'

  if (isAwaitingConfirmation) {
    return null
  }

  const handleDiscard = () => {
    discardStagedRoomAssignments()
  }

  const handleSave = async () => {
    await useCases.assignRoomsViaSwap()
  }

  return (
    <FloatingToolbar ariaLabel={intl.formatMessage({ id: 'groups_responsible_room_changes_toolbar_aria_label' })}>
      <FloatingToolbar.Item>
        <div className={styles.changesInfo}>
          <Typography variant="body-s-bold-tight">
            {intl.formatMessage(
              { id: 'groups_responsible_rooms_changed_count' },
              { count: changedCount },
            )}
          </Typography>
          {hasUnassignedParticipants && (
            <Typography variant="body-xs-bold-tight" className={styles.unassignedWarning}>
              {intl.formatMessage({ id: 'groups_responsible_unassigned_participants_warning' })}
            </Typography>
          )}
        </div>
      </FloatingToolbar.Item>
      <FloatingToolbar.Divider />
      <FloatingToolbar.Item className={styles.toolbarItem}>
        <Button
          size="S"
          variant="transparentNeutral"
          disabled={isSubmitting}
          onClick={handleDiscard}
        >
          {intl.formatMessage({ id: 'groups_responsible_discard_changes' })}
        </Button>
        <Button
          size="S"
          variant="primary"
          isLoading={isSubmitting}
          disabled={isSubmitting || hasUnassignedParticipants}
          onClick={handleSave}
        >
          {intl.formatMessage({
            id: isSubmitting
              ? 'groups_responsible_saving_changes'
              : 'groups_responsible_save_changes',
          })}
        </Button>
      </FloatingToolbar.Item>
    </FloatingToolbar>
  )
}
